import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number = 100): string {
    return value.length < limit
      ? value
      : value.slice(0, limit) + '…';
  }

}
